module.exports = __webpack_public_path__ + "fonts/GT-Cinetype-Regular.a8c830df.eot";